import styled from "styled-components"

export const BlogTagContainer = styled.div`
  display: ${({ hasTag }) => (hasTag ? "flex" : "none")};
  flex-direction: row;
  flex-wrap: wrap;
`
BlogTagContainer.displayName = "BlogTagContainer"

const isOpen = ({ isOpen }) => {
  if (isOpen)
    return `
    height: 100%;
    overflow: visible;
  `
  else
    return `
    height: 36px;
    overflow: hidden;
  `
}

export const TagsContainer = styled.div`
  width: calc(100% - 25px);
  min-height: 36px;
  ${isOpen};
`

const rotateIfOpen = ({ isCheveronOpen }) => {
  if (isCheveronOpen)
    return `
        transform: scaleY(-1); 
        transition: transform 0.5s
    `
  else
    return `
      transform: rotate(0deg); 
        transition: transform 0.5s
    `
}

export const CheveronIcon = styled.div`
  background: #f6f6fb;
  border-radius: 50%;
  height: 25px;
  width: 25px;
  margin-top: 10px;
  color: #4c0ffb;
  display: flex;
  &:hover {
    border: 1px solid #4c0ffb;
  }
  & svg {
    margin: auto;
    align-items: center;
    align-content: center;
    ${rotateIfOpen}
  }
`
CheveronIcon.displayName = "CheveronIcon"
